























import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import usuarioModule from "@/store/modules/usuario-module";
import centrosModule from "@/store/modules/centros-module";
import { Usuario } from "@/shared/dtos/usuario";
import rolModule from "@/store/modules/rol-module";
import router from "@/router/router";
import { RouterNames } from "@/router/routernames";
import { MessageService } from "@/shared/services/message-service";

@Component({
  components: {},
})
export default class usuarioFormulario extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: Usuario = new Usuario();

  public async OnCreated() {
    this.ShowLoading();

    if (this.getparamId().HayParametro) {
      await usuarioModule.getusuario(this.getparamId().Parametro);
      this.item_pantalla = usuarioModule.usuario;
    }
    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
    this.HideLoading();
    await Promise.all([rolModule.getroles(), centrosModule.getcentros()]);
  }

  public CreateNameTabs() {
    this.AddTabName("Ficha");
  }

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.AddFormItemDataDefaultString(
      this.item_pantalla.nombre,
      "Nombre",
      "nombre",
      60
    )
      .isRequired()
      .Dimesiones(12, 4, 2);

    this.AddFormItemDataDefaultString(this.item_pantalla.nif, "Nif", "nif", 50)
      .Dimesiones(12, 4, 2)
      .isRequired()
      .CrearValidacion("nie");

    this.AddFormItemDataDefaultString(
      this.item_pantalla.email,
      "Email",
      "email",
      50
    )
      .Dimesiones(12, 6, 4)
      .isRequired()
      .CrearValidacion("email");

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_rol,
      "Rol",
      "id_rol"
    )
      .Dimesiones(12, 6, 4)
      .isRequired()
      .CreateComboSingleCodigoDescripcionNames(rolModule.roles, "nombre", "id");

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_centro,
      "Centro",
      "id_centro"
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingleCodigoDescripcionNames(
        centrosModule.centros,
        "nombre",
        "id"
      );

    this.AddFormItemDataDefaultString(
      this.item_pantalla.contra,
      "Contraseña",
      "contra"
    )
      .Dimesiones(12, 6, 4)
      .isRequired(this.EstoyCreado)
      .isVisible(this.EstoyCreado);

    this.AddFormItemDataDefaultBoolean(
      this.item_pantalla.cambiar_pwd_entrar,
      "Cambiar contraseña al entrar",
      "cambiar_pwd_entrar",
      1,
      "Cambiar contraseña al entrar",
      "Cambiar contraseña al entrar"
    )
      .Dimesiones(12, 6, 4)
      .isVisible(this.EstoyCreado);

    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.descripcion,
      "sfffsdfsdf",
      "asfdwef4",
      50
    )
      .CreateInNewROW()
      .Dimesiones(12, 12, 12)
      .isVisible(!this.EstoyCreado);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.descripcion,
      "Descripción",
      "descripcion",
      50
    )
      .Dimesiones(12, 4, 2)
      .CreateTextArea();
  }

  public Insertar(object: Usuario) {
    if (
      !object.ids_datos_empresa ||
      !Array.isArray(object.ids_datos_empresa) ||
      object.ids_datos_empresa.length === 0
    ) {
      // Evita error backend post-insert cuando no llegan empresas asociadas.
      // Prioriza el cliente actual y usa 1 solo como último fallback.
      object.ids_datos_empresa = [object.id_cliente || 1];
    }
    usuarioModule.guardarusuario(object).then(() => {
      this.$router.push({
        name: RouterNames.usuarioslista,
      });
      setTimeout(() => this.AllSaveOk(), 500);
    });
  }

  public Actualizar(object: Usuario) {
    usuarioModule.modificarusuario(object).then(() => {
      this.$router.push({
        name: RouterNames.usuarioslista,
      });
      setTimeout(() => this.AllSaveOk(), 500); //guardo correctamente y me cierro
    });
  }

  public DontSave(event: any) {
    const errors = Array.isArray(event) ? event : [];
    if (!errors.length) {
      super.DontSave(event);
      return;
    }

    const fields = Array.from(
      new Set(
        errors
          .map((x: any) => (x && x.field ? String(x.field) : ""))
          .filter((x: string) => x.trim() !== "")
          .map((x: string) => x.replace(" *", "").trim())
      )
    );

    if (fields.length) {
      MessageService.toast(
        "Campos no válidos: " + fields.join(", "),
        MessageService.TypeWarning
      );
      return;
    }

    super.DontSave(event);
  }
}
